import React from 'react';

const Panel = ({ title, children, headerContent }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded shadow overflow-hidden border border-gray-200 dark:border-gray-700 transition-colors duration-200">
      <div className="p-4 px-6 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white m-0">{title}</h2>
          {headerContent && (
            <div className="ml-4">
              {headerContent}
            </div>
          )}
        </div>
      </div>
      <div className="p-4 px-6">
        {children}
      </div>
    </div>
  );
};

export default Panel;
